export default __webpack_public_path__ + "static/media/info.86514467.svg";